// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".upgrade-desc {\n  line-height: 1.4rem;\n  margin-bottom: 0;\n  font-size: 0.875rem;\n}\n.header {\n  font-size: large;\n  font-weight: 550;\n  padding-left: 0;\n}", ""]);
// Exports
module.exports = exports;
